import React, { useEffect } from "react";
import home_bg from "../assets/home_bg.svg";
import myWali from "../assets/myWali.png";
import logo from "../assets/main_header_logo.png";
import { Link } from "react-scroll";
import AOS from 'aos';
import 'aos/dist/aos.css';
function Home() {
  useEffect(() => {
    AOS.init({
      duration: 1000,
    });
  }, [])
  return (
    <div
    id="home"
      className="flex items-center 2xl:h-[85vh]"
      style={{ background: `url(${home_bg})`, backgroundSize: "cover" }}
    >
      <div className="pl-5 sm:pl-10 md:pl-20  md:w-[50%] pt-5 md:pt-2 pb-10 ">
        <div className="text-white text-2xl sm:text-3xl font-yeseva mt-10" data-aos="fade-up" data-aos-duration="800">
          Welcome To
        </div>
        <div>
          <img className="w-60 sm:w-80" src={myWali} alt="" data-aos="fade-up" data-aos-duration="1000"/>
        </div>
        {/* <div className="text-white text-4l sm:text-5xl pt-5 font-yeseva" data-aos="fade-up" data-aos-duration="1200">
          Guidedby faith, <br /> United by love
        </div> */}
        <div className="text-white text-xl sm:text-2xl pt-5 font-sans" data-aos="fade-up" data-aos-duration="1200">
          The <span className="font-bold"> ONLY </span> Fully Guided and Trusted Islamic Marriage Platform, Created
          for Parents by Parents.
        </div>
        <div className="leading-5 pr-10 md:pr-0 text-white font-poppins text-start pt-5 md:text-[15px]" data-aos="fade-up" data-aos-duration="1400">
          In the journey of finding a life partner, family support is
          invaluable. My Wali seamlessly bridges tradition and technology,
          enabling both parents and seekers to collaborate in the search for the
          perfect match. Our platform is designed to uphold the values of
          respect, Islamic principles, and family unity. When parents/guardians
          face challenges in finding the right partner for their children, My
          Wali empowers both generations to work hand in hand, creating a
          supportive, respectful, and guided approach to marriage.
        </div>
        <div className="py-5">
          <button  className="bg-white hover:scale-105 transition-all duration-300 text-themeColor px-4 sm:px-10 font-yeseva text-lg sm:text-2xl py-2 sm:py-3 rounded-full">
          <Link
          to="contact"
          duration={500}
          offset={-70}
        >
          Get Started
        </Link>
          </button>
        </div>
      </div>
      <div className="hidden md:w-[50%] md:flex justify-center items-center px-10">
        <img className="h-[300px] 2xl:h-[400px]" src={logo} alt="" />
      </div>
    </div>
  );
}

export default Home;
